import { render, staticRenderFns } from "./JsonCard.vue?vue&type=template&id=c9764900"
import script from "./JsonCard.vue?vue&type=script&lang=js"
export * from "./JsonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports